export enum Projektrolle {
    None = -1,
    Projektleiter = 1,
    Projektleiterassistent = 2,
    Projektmitarbeiter = 3,
    Projektassistent = 4,
    Administrator = 100,
    InstitutsAbteilungsleiter = 101,
    Geschäftsführung = 102,
    Rechnungswesen = 103,
    Controlling = 104,
    Vertragskoordination = 105,
    Forschungskoordination = 106,
    Website = 108,
    Personal = 110,
    Rektorat = 111,
    IKBManagement = 114
}